<!-- =========================================================================================
    File Name: Company.vue
    Description: Tabs - Imports all Company portions
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div id="company">
        <div class="mt-5">
            <vs-tabs alignment="center" :color="tabColor">
                <vs-tab label="Company" icon-pack="feather" icon="icon-package" @click="tabColor = 'green'" >
                    <company-list></company-list>
                </vs-tab>
                <vs-tab label="Branches" icon-pack="feather" icon="icon-home" @click="tabColor = 'red'" v-if="(RoleId == 2 ||  RoleId == 4) && clientId == 13" >
                    <branch-list></branch-list>
                </vs-tab>
                <vs-tab label="Company Registration" icon-pack="feather" icon="icon-home" @click="tabColor = 'red'" v-if="(RoleId == 2 ||  RoleId == 4) && clientId != 13" >
                    <company-registration-list></company-registration-list>
                </vs-tab>
            </vs-tabs>
        </div>
    </div>
</template>

<script>

import CompanyList from './company/CompanyList.vue'
import BranchList from './branch/BranchList.vue'
import CompanyRegistrationList from './companyRegistration/CompanyRegistrationList.vue'
import companyConfig from '@/company_config.json'

export default{
    components: {
        CompanyList,
        BranchList,
        CompanyRegistrationList
    },
    data() {
        return {
            tabColor: 'green',

            clientId: companyConfig.clientId,
            RoleId: '',            
        }
    },
  beforeMount() {    
    if (!this.$session.exists()) {
      console.log('your session is expired');
      this.$router.push('/');      
    }else{

      var server_url=companyConfig.apiURL;
      var role=this.$session.get('role');
      console.log('server_url='+server_url+', role='+role);
      if (role != "") {
        this.RoleId = role;
      }
    }
  },    
}
</script>